import { z } from 'zod';

export const versionManifestSchema = z.object({
    version: z.string().trim().min(1),
});

export type VersionManifest = z.infer<typeof versionManifestSchema>;
